import MetaField from "./ui/MetaField";
import { formatRestrictionDate } from "../utils/formatters";

export default function RestrictionPanel({ restriction, label }) {
  const { start, end, reason, createdBy, editedBy, updatedAgo } = restriction;

  return (
    <div className="border border-[#DDDDDD] rounded p-3 flex flex-col gap-2">
      <span className="text-[16px] font-bold">{label}</span>
      <div className="h-px bg-[#DDDDDD]" />
      <div className="grid grid-cols-2 gap-3">
        <MetaField label="Starts At" value={formatRestrictionDate(start)} />
        <MetaField label="Ends At" value={formatRestrictionDate(end)} />
      </div>

      <div className="h-px bg-[#DDDDDD]" />

      <MetaField label="Reason" value={reason} />

      <div className="h-px bg-[#DDDDDD]" />

      <div className="flex flex-col gap-1">
        <div className="flex flex-col gap-0.5 sm:flex-row sm:items-center sm:justify-between">
          <span className="text-[14px] text-gray-500">
            Created by{" "}
            <span className="font-bold text-gray-700">{createdBy}</span>
          </span>
          {updatedAgo && (
            <span className="text-[14px] text-gray-500">
              Updated{" "}
              <span className="font-bold text-gray-700">{updatedAgo}</span>
            </span>
          )}
        </div>
        {editedBy?.length > 0 && (
          <span className="text-[14px] text-gray-500">
            Edited by{" "}
            <span className="font-bold text-gray-700">
              {editedBy.join(", ")}
            </span>
          </span>
        )}
      </div>
    </div>
  );
}
